import threeShim from '../../shim/three';

const { Vector3, Matrix4 } = threeShim;

const getOverlappingChairs = (startPos, endPos, chairs, matrix) => {
    const result = [];
    const { id, x, y } = chairs;

    const p = new Vector3();

    for (let i = 0; i < id.length; i++) {
        const seatId = id[i];

        if (seatId) {
            const seatX = x[i];
            const seatY = y[i];

            p.set(seatX, seatY, 0);
            p.applyMatrix4(matrix);
            if (
                p.x >= startPos.x &&
                p.x <= endPos.x &&
                p.y >= startPos.y &&
                p.y <= endPos.y
            ) {
                result.push(seatId);
            }
        }
    }
    return result;
};

const getOverlappingObjects = (startPos, endPos, iter, matrix) => {
    let result = [];

    if (!iter) {
        return result;
    }

    let matrixToUse = matrix ? matrix : new Matrix4();

    if (iter.properties) {
        const { x, y, angle } = iter.properties;

        if (x !== undefined && y !== undefined) {
            let theta = angle;

            if (theta) {
                theta = (theta * Math.PI) / 180;
            }
            const objMatrix = new Matrix4();

            objMatrix.makeRotationZ(theta || 0);
            objMatrix.setPosition(new Vector3(x, y, 0));
            matrixToUse = matrix.clone().multiply(objMatrix);
        }
    }

    if (iter.chairs) {
        result = [
            ...getOverlappingChairs(startPos, endPos, iter.chairs, matrixToUse),
        ];
    }
    if (iter.contents) {
        Object.keys(iter.contents).forEach((key) => {
            const child = iter.contents[key];
            const childResult = getOverlappingObjects(
                startPos,
                endPos,
                child,
                matrixToUse,
            );

            result = [...result, ...childResult];
        });
    }
    return result;
};

export default {
    getOverlappingObjects,
};
